import { FormattedMessage } from 'react-intl';

import styles from '@components/automations/Automation.module.css';
import AutomationTriggerBlockForm from '@components/automations/forms/AutomationTriggerBlockForm';
import BodyCopy from '@components/typography/BodyCopy';
import Heading3 from '@components/typography/Heading3';
import { AutomationFragment as AutomationType } from '@typing/Generated';

type AutomationTriggerBlock = Extract<AutomationType['blocks'][number], { __typename: 'AutomationTriggerBlock' }>;

type Props = {
  automationTriggerBlock: AutomationTriggerBlock;
  locked: boolean;
};

const AutomationTriggerBlockPanel = ({ automationTriggerBlock, locked }: Props) => (
  <>
    <Heading3>
      <FormattedMessage id="models.automation.triggerBlock" />
    </Heading3>
    {automationTriggerBlock.triggerBrokenReason && (
      <div className={styles.brokenAutomationExplanation}>
        <BodyCopy color="error500">
          <FormattedMessage
            id={`models.automationTriggerBlock.brokenReasons.${automationTriggerBlock.triggerBrokenReason}`}
          />
        </BodyCopy>
      </div>
    )}
    <AutomationTriggerBlockForm automationTriggerBlock={automationTriggerBlock} locked={locked} />
  </>
);

export default AutomationTriggerBlockPanel;
